module.exports = __webpack_public_path__ + "img/icon-sepa-green@3x.94e842e8.png";